export interface PasswordValidity {
  valid: boolean;
  details: {
    length: boolean;
    numbers: boolean;
    lowercase: boolean;
    uppercase: boolean;
    specialChar: boolean;
    characters: boolean;
  };
}

function isPartialValid(input: boolean[], minValid: number): boolean {
  const trueInputs = input.filter(Boolean);

  return trueInputs.length >= minValid;
}

function checkPasswordValidity(password: string): PasswordValidity {
  const requiredLength = 8;
  const length = password.length >= requiredLength;
  const numbers = /\d/.test(password);
  const lowercase = password.toUpperCase() !== password;
  const uppercase = password.toLowerCase() !== password;
  const specialChar = /[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(password);
  const partialValid = isPartialValid(
    [numbers, lowercase, uppercase, specialChar],
    3,
  );

  return {
    valid: length && partialValid,
    details: {
      length,
      numbers,
      lowercase,
      uppercase,
      specialChar,
      characters: partialValid,
    },
  };
}

export default checkPasswordValidity;
